import { useMutation } from '@tanstack/react-query';

import { MutationProps } from '~/types/mutation';
import { queryClient } from '~/utils';

import { model } from '../';

import { expensesQueryKey } from './';

export const useDeleteExpense = ({ onSuccess }: MutationProps) =>
  useMutation(model.delete, {
    onSuccess: () => {
      queryClient.invalidateQueries([expensesQueryKey]);
      onSuccess?.();
    },
  });
